export default __webpack_public_path__ + "static/media/chat_bot_image16.98e6ebf6.jpg";